



export const swart = 'https://zx.ousuiot.com/api' 

export const baerUrl= 'https://www.ousuiot.com/login'//跳转路径


// export const baojing = 'http://www.0531yun.cn/default/images/alarming.png'//报警图片

// export const zhenchangtupian = 'http://www.0531yun.cn/default/images/online.png'//正常图片信息

// export const lixiantupian = 'http://www.0531yun.cn/default/images/offline.png'//离线 图片

export const baojing = 'https://zx.ousuiot.com/default/images/alarming.png'//报警图片

export const zhenchangtupian = 'https://zx.ousuiot.com/default/images/online.png'//正常图片信息

export const lixiantupian = 'https://zx.ousuiot.com/default/images/offline.png'//离线 图片

/**
 * 
 * 

 * 
 * 
 */
